import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { CreateTest } from './CreateTest/CreateTest';
import { useModalToggle } from '../../../../../shared/hooks/useModalToggle';
import { medicalTestsStore } from '../../../../stores/medicalTestsStore';
import { TestsPlaceholder } from './TestsPlaceholder/TestsPlaceholder';
import { EntityTestsBox } from './EntityTestsBox/EntityTestsBox';

const NgzActiveCalendarEntityTestsTab = observer(() => {
  const [isCreateTestModalOpen, createTestModalHandler] = useModalToggle();

  const { isTestsDisabled, getTests } = medicalTestsStore;

  useEffect(() => {
    getTests();
  }, []);

  return (
    <>
      <CreateTest
        isModalOpen={isCreateTestModalOpen}
        modalHandler={createTestModalHandler}
      />
      {isTestsDisabled ? <TestsPlaceholder /> : <EntityTestsBox />}
    </>
  );
});

angularizeWithProviders(
  NgzActiveCalendarEntityTestsTab,
  'ngzActiveCalendarEntityTestsTab',
  {},
);

export default NgzActiveCalendarEntityTestsTab;
